class Breadcrumbs {
    constructor() {
        this.homeLink = document.querySelector('.logged-in .trail-begin a');
        if (this.homeLink) {
            this.changePath();
        }
    }

    changePath() {
        let path = '/esg-page/my-page';
        this.homeLink.href =  path;
    }
}

module.exports = Breadcrumbs;


// WEBPACK FOOTER //
// ./resources/js/classes/breadcrumbs.js